/* jquery.event.drag.min.js */
!function($){$.fn.drag=function(str,arg,opts){var type="string"==typeof str?str:"",fn=$.isFunction(str)?str:$.isFunction(arg)?arg:null;return 0!==type.indexOf("drag")&&(type="drag"+type),opts=(str==fn?arg:opts)||{},fn?this.bind(type,opts,fn):this.trigger(type)};var $event=$.event,$special=$event.special,drag=$special.drag={defaults:{which:1,distance:0,not:":input",handle:null,relative:!1,drop:!0,click:!1},datakey:"dragdata",noBubble:!0,add:function(obj){var data=$.data(this,drag.datakey),opts=obj.data||{};data.related+=1,$.each(drag.defaults,function(key,def){void 0!==opts[key]&&(data[key]=opts[key])})},remove:function(){$.data(this,drag.datakey).related-=1},setup:function(){if(!$.data(this,drag.datakey)){var data=$.extend({related:0},drag.defaults);$.data(this,drag.datakey,data),$event.add(this,"touchstart mousedown",drag.init,data),this.attachEvent&&this.attachEvent("ondragstart",drag.dontstart)}},teardown:function(){var data=$.data(this,drag.datakey)||{};data.related||($.removeData(this,drag.datakey),$event.remove(this,"touchstart mousedown",drag.init),drag.textselect(!0),this.detachEvent&&this.detachEvent("ondragstart",drag.dontstart))},init:function(event){if(!drag.touched){var results,dd=event.data;if(!(0!=event.which&&dd.which>0&&event.which!=dd.which)&&!$(event.target).is(dd.not)&&(!dd.handle||$(event.target).closest(dd.handle,event.currentTarget).length)&&(drag.touched="touchstart"==event.type?this:null,dd.propagates=1,dd.mousedown=this,dd.interactions=[drag.interaction(this,dd)],dd.target=event.target,dd.pageX=event.pageX,dd.pageY=event.pageY,dd.dragging=null,results=drag.hijack(event,"draginit",dd),dd.propagates))return results=drag.flatten(results),results&&results.length&&(dd.interactions=[],$.each(results,function(){dd.interactions.push(drag.interaction(this,dd))})),dd.propagates=dd.interactions.length,dd.drop!==!1&&$special.drop&&$special.drop.handler(event,dd),drag.textselect(!1),drag.touched?$event.add(drag.touched,"touchmove touchend",drag.handler,dd):$event.add(document,"mousemove mouseup",drag.handler,dd),!(!drag.touched||dd.live)&&void 0}},interaction:function(elem,dd){var offset=$(elem)[dd.relative?"position":"offset"]()||{top:0,left:0};return{drag:elem,callback:new drag.callback,droppable:[],offset:offset}},handler:function(event){var dd=event.data;switch(event.type){case!dd.dragging&&"touchmove":event.preventDefault();case!dd.dragging&&"mousemove":if(Math.pow(event.pageX-dd.pageX,2)+Math.pow(event.pageY-dd.pageY,2)<Math.pow(dd.distance,2))break;event.target=dd.target,drag.hijack(event,"dragstart",dd),dd.propagates&&(dd.dragging=!0);case"touchmove":event.preventDefault();case"mousemove":if(dd.dragging){if(drag.hijack(event,"drag",dd),dd.propagates){dd.drop!==!1&&$special.drop&&$special.drop.handler(event,dd);break}event.type="mouseup"}case"touchend":case"mouseup":default:drag.touched?$event.remove(drag.touched,"touchmove touchend",drag.handler):$event.remove(document,"mousemove mouseup",drag.handler),dd.dragging&&(dd.drop!==!1&&$special.drop&&$special.drop.handler(event,dd),drag.hijack(event,"dragend",dd)),drag.textselect(!0),dd.click===!1&&dd.dragging&&$.data(dd.mousedown,"suppress.click",(new Date).getTime()+5),dd.dragging=drag.touched=!1}},hijack:function(event,type,dd,x,elem){if(dd){var result,ia,callback,orig={event:event.originalEvent,type:event.type},mode=type.indexOf("drop")?"drag":"drop",i=x||0,len=isNaN(x)?dd.interactions.length:x;event.type=type,event.originalEvent=null,dd.results=[];do if(ia=dd.interactions[i]){if("dragend"!==type&&ia.cancelled)continue;callback=drag.properties(event,dd,ia),ia.results=[],$(elem||ia[mode]||dd.droppable).each(function(p,subject){if(callback.target=subject,event.isPropagationStopped=function(){return!1},result=subject?$event.dispatch.call(subject,event,callback):null,result===!1?("drag"==mode&&(ia.cancelled=!0,dd.propagates-=1),"drop"==type&&(ia[mode][p]=null)):"dropinit"==type&&ia.droppable.push(drag.element(result)||subject),"dragstart"==type&&(ia.proxy=$(drag.element(result)||ia.drag)[0]),ia.results.push(result),delete event.result,"dropinit"!==type)return result}),dd.results[i]=drag.flatten(ia.results),"dropinit"==type&&(ia.droppable=drag.flatten(ia.droppable)),"dragstart"!=type||ia.cancelled||callback.update()}while(++i<len);return event.type=orig.type,event.originalEvent=orig.event,drag.flatten(dd.results)}},properties:function(event,dd,ia){var obj=ia.callback;return obj.drag=ia.drag,obj.proxy=ia.proxy||ia.drag,obj.startX=dd.pageX,obj.startY=dd.pageY,obj.deltaX=event.pageX-dd.pageX,obj.deltaY=event.pageY-dd.pageY,obj.originalX=ia.offset.left,obj.originalY=ia.offset.top,obj.offsetX=obj.originalX+obj.deltaX,obj.offsetY=obj.originalY+obj.deltaY,obj.drop=drag.flatten((ia.drop||[]).slice()),obj.available=drag.flatten((ia.droppable||[]).slice()),obj},element:function(arg){if(arg&&(arg.jquery||1==arg.nodeType))return arg},flatten:function(arr){return $.map(arr,function(member){return member&&member.jquery?$.makeArray(member):member&&member.length?drag.flatten(member):member})},textselect:function(bool){$(document)[bool?"unbind":"bind"]("selectstart",drag.dontstart).css("MozUserSelect",bool?"":"none"),document.unselectable=bool?"off":"on"},dontstart:function(){return!1},callback:function(){}};drag.callback.prototype={update:function(){$special.drop&&this.available.length&&$.each(this.available,function(i){$special.drop.locate(this,i)})}};var $dispatch=$event.dispatch;$event.dispatch=function(event){return $.data(this,"suppress."+event.type)-(new Date).getTime()>0?void $.removeData(this,"suppress."+event.type):$dispatch.apply(this,arguments)};var touchHooks=$event.fixHooks.touchstart=$event.fixHooks.touchmove=$event.fixHooks.touchend=$event.fixHooks.touchcancel={props:"clientX clientY pageX pageY screenX screenY".split(" "),filter:function(event,orig){if(orig){var touched=orig.touches&&orig.touches[0]||orig.changedTouches&&orig.changedTouches[0]||null;touched&&$.each(touchHooks.props,function(i,prop){event[prop]=touched[prop]})}return event}};$special.draginit=$special.dragstart=$special.dragend=drag}(jQuery);
/**
 * jQuery Cross2 Plugin v1.0
 * Created by Nxeed
 * https://github.com/nxeed
 */
if (typeof Object.create !== "function") {
    Object.create = function(obj) {
        function F() {
        }
        F.prototype = obj;
        return new F();
    };
}

(function($, window, document) {
    var Cross2 = {
        $elem: null,
        $slider: null,
        $before: null,
        $after: null,
        $dummy: null,
        $overlay: null,
        $images: null,

        options: {},

        width: 0,
        height: 0,
        val: 0.5,

        init: function(options, el) {
            var base = this;

            this.$elem = $(el);

            this.options = $.extend({}, $.fn.cross2.options, this.$elem.data(), options);

            if (this.options.vertical == true) {
                this.$elem.addClass('cross2-vertical');
            }

            this.val = this.options.value;

            this.$images = this.$elem.find('img');

            this.$before = $('<div style="position: relative" class="cross2-item cross2-item-before"></div>');
            this.$after = $('<div style="position: relative" class="cross2-item cross2-item-after"></div>');

            this.$elem.append(this.$before);
            this.$elem.append(this.$after);

            if (this.$images.eq(0).parent().is('a')) {
                this.$before.append(this.$images.eq(0).parent());
                this.$after.append(this.$images.eq(1).parent());
            } else {
                this.$before.append(this.$images.eq(0));
                this.$after.append(this.$images.eq(1));
            }

            if (this.options.titlesEnabled) {
                this.$before.append('<span style="z-index: 2" class="cross2-item-title">' + this.options.titleBefore + '</span>');
                this.$after.append('<span style="z-index: 2" class="cross2-item-title">' + this.options.titleAfter + '</span>');
            }

            this.$before.css({
                position: 'absolute',
                width: '100%',
                zIndex: 2,
                top: 0
            });

            this.$after.css({
                position: 'absolute',
                width: '100%',
                zIndex: 1,
                top: 0
            });

            this.$dummy = $('<img src="'+this.$images.eq(0).attr('src')+'" alt="Cross2 Dummy" />');

            this.$dummy.css({
                position: 'relative',
                visibility: 'hidden'
            });

            this.$elem.append(base.$dummy);

            if (base.options.mousemoveEnabled == false) {
                this.$slider = $('<span tabindex="0" class="cross2-slider"><span></span></span>');
            } else {
                this.$slider = $('<div class="cross2-slider" tabindex="0"><span></span></div>');
            }

            this.$slider.attr({
                "role": "slider",
                "aria-label": "Before and after image slider",
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": Math.round(this.val * 100),
                "aria-orientation": this.options.vertical ? "vertical" : "horizontal"
            });

            this.$elem.append(base.$slider);

            this.$overlay = $('<div class="cross2-overlay" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 5;"></div>');
            this.$elem.append(base.$overlay);
            
            this.$live = $('<div class="cross2-live" aria-live="polite" aria-atomic="true" style="position:absolute;left:-9999px;height:1px;width:1px;overflow:hidden;"></div>');
            this.$elem.append(this.$live);

            this.$overlay.hide();

            this.$slider.bind('click.cross2', function(e) {
                if (base.options.mousemoveEnabled == false) {
                    $(this).focus();
                    base.refresh();
                }

                e.preventDefault();
            });

            if (this.options.mousemoveEnabled == false) {
                this.$slider.bind('focusin.cross2', function(e) {
                    base.$elem.addClass('cross2-focused');
                });

                this.$slider.bind('focusout.cross2', function(e) {
                    base.$elem.removeClass('cross2-focused');
                });
            }

            if (this.options.mousemoveEnabled == false) {
                this.$slider.bind('keydown.cross2', function(e) {

                    if (base.options.vertical == true && (e.keyCode == 38 || e.keyCode == 40)) {
                        base.set(e.keyCode == 38 ? base.val - 0.05 : base.val + 0.05);
                        base.refresh();
                    } else if(base.options.vertical == false && (e.keyCode == 37 || e.keyCode == 39)) {
                        base.set(e.keyCode == 37 ? base.val - 0.05 : base.val + 0.05);
                        base.refresh();
                    }
                });
            }

            this.$slider.css({
                zIndex: 3
            });

            $(window).resize(function() {
                base.refresh();
                base.$elem.stop(true, false);
            });

            var currentVal = 0;

            if (this.options.mousemoveEnabled == false) {
                this.$slider.bind('dblclick.cross2', function(e) {
                    base.showHalfs();
                });
            }

            if (this.options.clickEnabled == true && this.options.mousemoveEnabled == false) {
                this.$elem.bind('mousedown.cross2', function(e) {
                    var offset = base.options.vertical == true ? e.pageY - $(this).offset().top : e.pageX - $(this).offset().left;
                    base.moveToOffset(offset);
                });
            }

            if (this.options.mousemoveEnabled == true) {
                this.$elem.bind('mousemove.cross2', function(e) {
                    var offset = base.options.vertical == true ? e.pageY - $(this).offset().top : e.pageX - $(this).offset().left;
                    base.setOffset(offset);
                    base.refresh();
                });
            }

            if (this.options.mousewheelEnabled == true && this.options.mousemoveEnabled == false) {
                this.$elem.bind('mousewheel.cross2', function(e) {
                    if (e.deltaY < 0 && base.val == (base.options.vertical == true ? 1 : 0) || e.deltaY > 0 && base.val == (base.options.vertical == true ? 0 : 1)) {
                        return false;
                    }

                    e.preventDefault();

                    var upVal = base.options.vertical == true ? base.val - 0.05 : base.val + 0.05;
                    var downVal = base.options.vertical == true ? base.val + 0.05 : base.val - 0.05;

                    base.set(e.deltaY > 0 ? upVal : downVal);
                    base.refresh();
                });
            }

            this.$slider.bind('dragstart.cross2', function(e, dd) {
                base.$elem.addClass('cross2-drag');
                currentVal = base.val;
                base.$overlay.show();

                if (base.options.mousemoveEnabled == false) {
                    base.$slider.focus();
                }
            }).bind('dragend.cross2', function(e, dd) {
                base.$elem.removeClass('cross2-drag');
                base.$overlay.hide();
            });

            base.$elem.on('mousemove touchmove mouseleave', function(e){
                if (!base.$elem.hasClass('cross2-drag')) return;

                var containerOffset, offset;

                //console.log(e.originalEvent.layerX, e.originalEvent.clientX, e.originalEvent.offsetX, e.originalEvent.pageX, e.originalEvent.screenX, e.originalEvent.x);

                if (base.options.vertical == true) {
                    containerOffset = $(this).offset().top;
                    offset = e.type == 'touchmove' ? e.originalEvent.touches[0].pageY - containerOffset : e.originalEvent.offsetY;
                }
                else {
                    containerOffset = $(this).offset().left;
                    offset = e.type == 'touchmove' ? e.originalEvent.touches[0].pageX - containerOffset : e.originalEvent.offsetX;
                }

                base.setOffset(offset);
                base.refresh();
            });

            base.refresh();

            return this;
        },
        setOffset: function(offset) {
            var k = this.options.vertical == true ? this.height : this.width;

            if (offset > k) {
                offset = k;
            } else if(offset < 0) {
                offset = 0;
            }

            var val = offset / k;
            this.val = val;
            return this;
        },
        set: function(val) {
            var k = this.options.vertical == true ? this.height : this.width;

            this.setOffset(k * val);

            return this;
        },
        refresh: function() {
            this.width = this.$dummy.outerWidth();
            this.height = this.$dummy.outerHeight();
            this.$elem.scrollTop(0);
            this.$elem.scrollLeft(0);
            var k = this.options.vertical == true ? this.height : this.width;

            var offset = Math.floor(k * this.val);
            var offsetType = this.options.vertical == true ? 'top' : 'left';
            this.$slider.css(offsetType, offset + 'px');

            var clip = this.options.vertical == true 
                ? 'rect(0, ' + this.width + 'px,' + offset + 'px, 0)'
                : 'rect(0, ' + offset + 'px,' + this.height + 'px, 0)';

            this.$before.css('clip', clip);

            var valueNow = Math.round(this.val * 100);

            if (this.$slider) {
                this.$slider.attr("aria-valuenow", valueNow);
            }

            var ariaLiveMessage = '';

            if (valueNow == 0) {
            	ariaLiveMessage = 'Showing before image';
            }
            else if (valueNow == 100) {
            	ariaLiveMessage = 'Showing after image';
            }
            else {
            	ariaLiveMessage = 'Showing combined before and after image';
            }


            this.announce(ariaLiveMessage);

            return this;
        },
        moveToOffset: function(offset) {
            var base = this;
            var offsetType = this.options.vertical == true ? 'top' : 'left';

            var animationOptions = {
                duration: this.options.animationDuration,
                easing: this.options.easing,
                step: function() {
                    base.setOffset(parseInt(base.$slider.css(offsetType))).refresh();
                },
                complete: function() {
                    base.setOffset(parseInt(base.$slider.css(offsetType))).refresh();
                }
            };

            if (this.options.vertical == true) {
                this.$slider.stop(true, false).animate({top: offset}, animationOptions);
            } else {
                this.$slider.stop(true, false).animate({left: offset}, animationOptions);
            }

            return this;
        },
        moveTo: function(val) {
            var k = this.options.vertical == true ? this.height : this.width;
            this.moveToOffset(k * val);

            return this;
        },
        showBefore: function() {
            var k = this.options.vertical == true ? this.height : this.width;
            this.moveToOffset(k);

            return this;
        },
        showAfter: function() {
            this.moveToOffset(0);

            return this;
        },
        showHalfs: function() {
            var k = this.options.vertical == true ? this.height : this.width;
            this.moveToOffset(k / 2);

            return this;
        },
        destroy: function() {
            var base = this;
            this.$elem.unbind('.cross2');
            this.$elem.removeData();
            this.$elem.removeClass('cross2-drag cross2-focused cross2-vertical');
            this.$slider.unbind('.cross2');
            this.$slider.remove();
            this.$dummy.remove();
            this.$overlay.remove();

            this.$images.each(function() {
                base.$elem.append($(this));
            });

            this.$before.remove();
            this.$after.remove();
        },
        announce: function(message) {
            if (this.$live && this.$live.text() !== message) {
                this.$live.text(message);
            }
        }
    };

    $.fn.cross2 = function(options) {
        return this.each(function() {
            if ($(this).data("cross2-init") == true) {
                return false;
            }

            $(this).data("cross2-init", true);
            var cross2 = Object.create(Cross2);

            cross2.init(options, this);
            $.data(this, "cross2", cross2);
        });
    };

    $.fn.cross2.options = {
        value: 0.5,
        vertical: false,
        animationDuration: 150,
        easing: 'swing',
        clickEnabled: false,
        mousemoveEnabled: false,
        mousewheelEnabled: false,
        titlesEnabled: true,
        titleBefore: 'Before',
        titleAfter: 'After'
    };

}(jQuery, window, document));